import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Inquiry } from '../shared/model/Inquiry';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AdminInquiryService } from '../shared/service/admin-inquiry.service';
import { AdminDestinationService } from '../shared/service/admin-destination.service';
@Component({
  selector: 'app-inquiry',
  templateUrl: './inquiry.component.html',
  styleUrls: ['./inquiry.component.css']
})
export class InquiryComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  destinationArr = [];
  travelDate;
  constructor(public dialogRef: MatDialogRef<InquiryComponent>, @Inject(MAT_DIALOG_DATA) public data: Inquiry, private adminInquiryService: AdminInquiryService, private adminDestinationService: AdminDestinationService) {

  }

  ngOnInit() {
    this.getDestination();
  }

  addInquiry() {
    if (this.data) {
      this.data.Status = "Pending";
      if (this.data.TravelDate) {
        this.travelDate = (this.data.TravelDate.getMonth() + 1) + "/" + this.data.TravelDate.getDate() + "/" + this.data.TravelDate.getFullYear();
        this.data.TravelDate = this.travelDate;
      }

      this.data.TravelDuration = this.data.TravelDuration + " Days";
    }
    this.blockUI.start('Please wait...');
    this.adminInquiryService
      .addInquiry(this.data)
      .then((result) => {
        this.clearControl();
        this.dialogRef.close();
        this.blockUI.stop();
      })
      .catch((err) => this.errorHandler(err));

  }

  errorHandler(err: any) {
    this.blockUI.stop();
  }

  clearControl() {
    this.data;
  }

  isInputNumber(event) {
    var key = window.event ? event.keyCode : event.which;
    if (event.keyCode === 8 || event.keyCode === 46) {
      return true;
    } else if (key < 48 || key > 57) {
      return false;
    } else {
      return true;
    }
  }

  getDestination() {
    this.adminDestinationService
      .getDestination()
      .then((result) => { this.destinationArr = result; })
      .catch((err) => { console.log(err); });
  }

}
